module.exports = __webpack_public_path__ + "img/wine-glass-crack.4bf54f8e.svg";